import React from "react";
import { Modal, Button, Row, Col, Table, Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { formatExpiry } from "../../generals/utils";

const ModalInfoCard = ({ show, handleClose, info, handleAcceptPay }) => {
    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title><FormattedMessage id="step.modal.title"/></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='justify-content-center'>
                        <Col md={{span: 12}} sm={{span: 12}}>
                            <Table>
                                <thead className="famsa-btn-blue">
                                    <tr>
                                        <th><FormattedMessage id="step.modal.name"/></th>
                                        <th><FormattedMessage id="step.modal.numbermask"/></th>
                                        <th><FormattedMessage id="step.modal.typecard"/></th>
                                        <th><FormattedMessage id="step.modal.expiry"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{info?.name}</td>
                                        <td>{info?.numberMask}</td>
                                        <td><img src={info?.cartBrandImg} alt={info?.cartBrand} /></td>
                                        <td>{info?.expiry}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                        <Col md={{span: 12}} sm={{span: 12}}>
                            <p className="famsa-text-blue fw-bold fs-6"><FormattedMessage id="step.modal.subtitle"/></p>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}>
                        <FormattedMessage id="step.modal.cancel"/>
                    </Button>
                    <Button variant="success" onClick={handleAcceptPay}>
                        <FormattedMessage id="step.modal.acceptpay"/>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ModalInfoCard;